import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"
import { useScope } from './ScopeProvider'
import { useOrbit } from "providers/OrbitProvider";

export default function NavigateToSelected() {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const { currentClient, currentVendor, currentContract } = useScope()
  const { getRemoteId } = useOrbit()

  useEffect(() => {
    const match = currentPath.match(/^\/(clients|vendors|contracts)\/(\d+)(.*)/)
    if(!match) {
      return
    }

    let currentEntity

    switch(match[1]) {
      case 'clients':
        currentEntity = currentClient
        break
      case 'vendors':
        currentEntity = currentVendor
        break
      case 'contracts':
        currentEntity = currentContract
        break
    }

    if(!currentEntity) {
      return
    }

    const newPath = `/${match[1]}/${getRemoteId(currentEntity)}${match[3]}`

    if(newPath !== currentPath) {
      navigate(newPath)
    }
  }, [currentClient, currentPath, currentVendor, currentContract, navigate, getRemoteId])

  return null
}
